export default __webpack_public_path__ + "static/media/js.632e03e5.svg";